import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/useIdentityBadgeQuery.ts
var r = (r) => t({
	queryKey: e.identityBadge(r ?? ""),
	queryFn: () => n.getIdentityBadge(r),
	enabled: !!r
});
//#endregion
export { r as useIdentityBadgeQuery };
